import { IContentUpdateClientFormType, Contrato} from "@/shared/interfaces"
// import { ClienteInfoSummaryFormPart } from "../../fibra-optica/shared/components/form/parts"
import { CustomAutocomplete, CustomNumberTextField, CustomTextField, TabTextLabel } from "@/shared/components/ui";
import { UseFormReturn } from "react-hook-form";
import { gridSizeMdLg6, parentescoMockupData } from "@/shared";
import { InputAdornment, SvgIcon } from "@mui/material";
import GlobeEuropeAfricaIcon from "@heroicons/react/24/solid/GlobeEuropeAfricaIcon";
import CustomCellphoneTextField from "@/shared/components/ui/CustomCellphoneTextField";

interface DatosPersonalesClienteProps{
    contract?:Contrato;
    form: UseFormReturn<IContentUpdateClientFormType>;
}

const DatosPersonalesCliente:React.FC<DatosPersonalesClienteProps> = ({
    // contract,
    form
}) => {
    
    const { errors } = form.formState;
  

    return(
        <>
            {/* ===================== Cliente Info ===================== */}
            <CustomTextField
                name="razon_social"
                label="Nombre"
                control={form.control}
                defaultValue={form.getValues().razon_social || ''}
                error={errors.razon_social}
                helperText={errors.razon_social?.message?.toString() ?? ''}
                shrink
            />
            <CustomTextField
                label="Tipo de Documento"
                name="tipo_identificacion"
                control={form.control}
                defaultValue={form.getValues().tipo_identificacion || ''}
                error={errors.tipo_identificacion}
                helperText={errors.tipo_identificacion?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="identificacion"
                label="No. Identificación"
                control={form.control}
                defaultValue={form.getValues().identificacion || ''}
                error={errors.identificacion}
                helperText={errors.identificacion?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="fecha_nacimiento"
                label="Fecha de Nacimiento"
                control={form.control}
                defaultValue={form.getValues().fecha_nacimiento || ''}
                error={errors.fecha_nacimiento}
                helperText={errors.fecha_nacimiento?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="edad"
                label="Edad"
                control={form.control}
                defaultValue={form.getValues().edad || ''}
                error={errors.edad}
                helperText={errors.edad?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />

            <CustomTextField
                name="pais_data.nombre"
                label="País"
                control={form.control}
                defaultValue={form.getValues().pais_data?.nombre || ''}
                error={errors.pais}
                helperText={errors.pais?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="provincia_data.nombre"
                label="Provincia"
                control={form.control}
                defaultValue={form.getValues().provincia_data?.nombre || ''}
                error={errors.provincia_data?.nombre}
                helperText={errors.provincia_data?.nombre?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="ciudad_data.nombre"
                label="Ciudad"
                control={form.control}
                defaultValue={form.getValues().ciudad_data?.nombre || ''}
                error={errors.ciudad_data?.nombre}
                helperText={errors.ciudad_data?.nombre?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="zona_data.nombre"
                label="Zona"
                control={form.control}
                defaultValue={form.getValues().zona_data?.nombre || ''}
                error={errors.zona_data?.nombre}
                helperText={errors.zona_data?.nombre?.message?.toString() ?? ''}
                shrink
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                name="sector_data.nombre"
                label="Sector"
                control={form.control}
                defaultValue={form.getValues().sector_data?.nombre || ''}
                error={errors.sector_data?.nombre}
                helperText={errors.sector_data?.nombre?.message?.toString() ?? ''}
                shrink
                disabled
            />

            <CustomTextField
                name="direccion"
                label="Dirección"
                control={form.control}
                defaultValue={form.getValues().direccion || ''}
                error={errors.direccion}
                helperText={errors.direccion?.message?.toString() ?? ''}
                shrink
            />
            <CustomNumberTextField
                label="Coordenadas"
                name="coordenadas"
                defaultValue={form.getValues().coordenadas || ''}
                control={form.control}
                error={errors.coordenadas}
                helperText={errors.coordenadas?.message}
                shrink
                startAdornment={
                <InputAdornment position="start">
                    <SvgIcon fontSize="small">
                    <GlobeEuropeAfricaIcon />
                    </SvgIcon>
                </InputAdornment>
                }
                min={-90}
                max={90}
                disabled
            />

            <CustomCellphoneTextField
                name="celular"
                label="Celular"
                control={form.control}
                defaultValue={form.getValues().celular || ''}
                error={errors.celular}
                helperText={errors.celular?.message}
                shrink
                size={gridSizeMdLg6}
            />
            <CustomCellphoneTextField
                name="celular_2"
                label="Celular 2"
                control={form.control}
                defaultValue={form.getValues().celular_2 || ''}
                error={errors.celular_2}
                helperText={errors.celular_2?.message}
                shrink
                size={gridSizeMdLg6}
                required={false}
            />
            <CustomTextField
                label="Correo Electrónico"
                name="email"
                control={form.control}
                defaultValue={form.getValues().email || ''}
                error={errors.email}
                helperText={errors.email?.message}
                shrink
                type="email"
            />

            {/* --------- referencia --------- */}
            <TabTextLabel text="Datos de Referencia" mt={6} />
            <CustomTextField
                name="persona_referencia_nombre"
                label="Persona de Referencia"
                control={form.control}
                defaultValue={form.getValues().persona_referencia_nombre || ''}
                error={errors.persona_referencia_nombre}
                helperText={errors.persona_referencia_nombre?.message}
                shrink
            />

            <CustomAutocomplete<any>
                size={gridSizeMdLg6}
                label="Parentesco"
                name="persona_referencia_parentesco"
                options={parentescoMockupData || []}
                valueKey="nombre" // name is the fk
                defaultValue={form.getValues().persona_referencia_parentesco || ''}
                isLoadingData={false}
                control={form.control}
                error={errors.persona_referencia_parentesco}
                helperText={errors.persona_referencia_parentesco?.message}
                disableClearable
            />

            <CustomCellphoneTextField
                name="persona_referencia_celular"
                label="Celular Persona Referencia"
                control={form.control}
                defaultValue={form.getValues().persona_referencia_celular || ''}
                error={errors.persona_referencia_celular}
                helperText={errors.persona_referencia_celular?.message}
                shrink
                size={gridSizeMdLg6}
            />
        </>
    )
}

export default DatosPersonalesCliente;